export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">焦点专题</h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">编辑精选热点专题，深度挖掘最受关注的黑料视频内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          <div className="lg:col-span-2 bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden cursor-pointer hover:border-primary-200 transition-all duration-200 group">
            <div className="aspect-[21/9] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20wide%20banner%20for%20entertainment%20news%20special%20topic%2C%20dark%20moody%20atmosphere%20with%20dramatic%20spotlight%2C%20warm%20amber%20and%20crimson%20accents%2C%20luxurious%20theater%20setting%2C%20professional%20editorial%20photography%2C%20high%20detail%2C%20rich%20textures%2C%20mysterious%20and%20exclusive%20vibe&width=1200&height=500&seq=carousel-01-2026&orientation=landscape"
                alt="年度重磅专题：娱乐圈黑料真相大揭秘"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
            </div>
            <div className="p-5 md:p-6">
              <div className="flex items-center gap-2 mb-3">
                <span className="px-3 py-1 bg-accent-500 text-background-50 text-xs font-semibold rounded-full">重磅专题</span>
                <span className="text-xs text-foreground-500">2026年度策划</span>
              </div>
              <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-900 mb-2">娱乐圈黑料真相大揭秘 · 年度重磅专题</h3>
              <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">深入追踪本年度娱乐圈最具话题性的黑料事件，从独家视频资料到深度分析，为你还原最真实的娱乐圈内幕。涵盖明星恋情、综艺黑幕、片场爆料等多个维度。</p>
            </div>
          </div>

          <div className="bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden cursor-pointer hover:border-primary-200 transition-all duration-200 group">
            <div className="aspect-[4/3] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20entertainment%20special%20topic%20visual%2C%20dark%20atmosphere%20with%20golden%20accents%2C%20mysterious%20studio%20interior%2C%20dramatic%20lighting%2C%20professional%20editorial%20style%2C%20high%20contrast%2C%20premium%20magazine%20aesthetic&width=600&height=450&seq=carousel-02-2026&orientation=landscape"
                alt="网红经济背后的黑暗面"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
            </div>
            <div className="p-4 md:p-5">
              <span className="px-2 py-0.5 bg-primary-100 text-primary-700 text-xs font-medium rounded-full mb-2 inline-block">深度报道</span>
              <h3 className="text-base font-semibold text-foreground-900 mb-1">网红经济背后的黑暗面</h3>
              <p className="text-sm text-foreground-600 line-clamp-2">揭秘网红行业的真实生态</p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 mt-4 md:mt-5">
          <div className="bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden cursor-pointer hover:border-primary-200 transition-all duration-200 group">
            <div className="aspect-[16/10] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20entertainment%20special%20topic%20visual%2C%20dark%20atmosphere%20with%20golden%20accents%2C%20mysterious%20studio%20interior%2C%20dramatic%20lighting%2C%20professional%20editorial%20style%2C%20high%20contrast%2C%20premium%20magazine%20aesthetic&width=600&height=375&seq=carousel-03-2026&orientation=landscape"
                alt="综艺节目剪辑猫腻全解析"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
            </div>
            <div className="p-4 md:p-5">
              <span className="px-2 py-0.5 bg-secondary-100 text-secondary-900 text-xs font-medium rounded-full mb-2 inline-block">独家分析</span>
              <h3 className="text-base font-semibold text-foreground-900 mb-1">综艺节目剪辑猫腻全解析</h3>
              <p className="text-sm text-foreground-600 line-clamp-2">那些被剪掉的真相都在这里</p>
            </div>
          </div>

          <div className="bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden cursor-pointer hover:border-primary-200 transition-all duration-200 group">
            <div className="aspect-[16/10] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20entertainment%20special%20topic%20visual%2C%20dark%20atmosphere%20with%20golden%20accents%2C%20mysterious%20studio%20interior%2C%20dramatic%20lighting%2C%20professional%20editorial%20style%2C%20high%20contrast%2C%20premium%20magazine%20aesthetic&width=600&height=375&seq=carousel-04-2026&orientation=landscape"
                alt="明星合约纠纷黑料汇总"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
            </div>
            <div className="p-4 md:p-5">
              <span className="px-2 py-0.5 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-2 inline-block">热点追踪</span>
              <h3 className="text-base font-semibold text-foreground-900 mb-1">明星合约纠纷黑料汇总</h3>
              <p className="text-sm text-foreground-600 line-clamp-2">最新解约风波时间线梳理</p>
            </div>
          </div>

          <div className="bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden cursor-pointer hover:border-primary-200 transition-all duration-200 group">
            <div className="aspect-[16/10] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20entertainment%20special%20topic%20visual%2C%20dark%20atmosphere%20with%20golden%20accents%2C%20mysterious%20studio%20interior%2C%20dramatic%20lighting%2C%20professional%20editorial%20style%2C%20high%20contrast%2C%20premium%20magazine%20aesthetic&width=600&height=375&seq=carousel-05-2026&orientation=landscape"
                alt="配音演员行业的辛酸内幕"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
            </div>
            <div className="p-4 md:p-5">
              <span className="px-2 py-0.5 bg-primary-100 text-primary-700 text-xs font-medium rounded-full mb-2 inline-block">行业揭秘</span>
              <h3 className="text-base font-semibold text-foreground-900 mb-1">配音演员行业的辛酸内幕</h3>
              <p className="text-sm text-foreground-600 line-clamp-2">光鲜背后的真实生存现状</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}